import { GETCUSTOMERS_SUCCESS, GETCUSTOMERS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getCustomersReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETCUSTOMERS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
                workspaceId: action.payload.workspaceId,
            };
        case GETCUSTOMERS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getCustomersReducer;
